<button mat-button [matMenuTriggerFor]="menu"
  class="block text-center py-1 px-4 bg-mj-morado-2 shadow-lg text-white rounded-lg">
  <span class="flex-grow">
    Hola, {{authService.getUser()?.first_name}}
  </span>


</button>
<mat-menu #menu="matMenu">
  <!-- <button *ngFor="let item of item?.sectors">{{item.name}}</button> -->
  <a routerLink="/perfil/informacio-usuario" class="block py-2 px-4 raleway-600 text-base hover:bg-gray-100">
    Tu perfil
  </a>
  <a *ngIf="authService.getUser()?.roles.length > 1" routerLink="/inicio-administrador"
    class="block py-2 px-4 raleway-600 text-base hover:bg-gray-100">Administrar</a>

  <div mat-menu-item class="flex py-1 bg-gray-700 w-full padin-menu">
    <a routerLink="/inicio" class="block py-2 px-4 raleway-600 text-base  hover:bg-gray-100 w-full" (click)="logOut()">Salir
    </a>
  </div>

</mat-menu>